import React from 'react';

export default function NoOwnersSchemaMessage({pluralName}: {pluralName?: string}): JSX.Element {
  return (
    <div>
      To create {pluralName || 'schemas'}, you must be an admin of an org or a member of a team that allows
      creating {pluralName || 'schemas'}.
    </div>
  );
}
